module.exports = __FOREMAN_VENDOR__RESELECT__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__RESELECT__"
// module id = reselect
// module chunks = 32